import gql from 'graphql-tag';

export default gql`
  mutation deleteChannel($channelId: UUID!) {
    archiveChannel(channelId: $channelId)
  }
`;
